import { render, staticRenderFns } from "./QuizPrologueCard.vue?vue&type=template&id=9a6c5758&scoped=true"
import script from "./QuizPrologueCard.vue?vue&type=script&lang=js"
export * from "./QuizPrologueCard.vue?vue&type=script&lang=js"
import style0 from "./QuizPrologueCard.vue?vue&type=style&index=0&id=9a6c5758&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a6c5758",
  null
  
)

export default component.exports